import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { adminLogin } from "../lib/auth";
import { toast } from "sonner";
import { Sparkles, LogIn } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(username, password);
      toast.success("Welcome back, Joseph.");
      nav("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error("Login failed", {
        description: err.response?.data?.detail || err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F6] flex flex-col">
      <header className="border-b border-black/5 bg-[#F9F9F6]/80 backdrop-blur sticky top-0">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#1A365D] text-white">
              <Sparkles className="h-4 w-4" />
            </span>
            <span className="font-serif text-xl text-[#111827]">
              No Grime,{" "}
              <span className="italic text-[#1A365D]">Window Shine</span>
            </span>
          </Link>
          <span className="text-xs uppercase tracking-[0.2em] text-[#4B5563]">
            Admin
          </span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <form
          onSubmit={submit}
          className="w-full max-w-md rounded-3xl bg-white border border-black/5 p-8 md:p-10 shadow-[0_20px_60px_rgba(0,0,0,0.06)]"
          data-testid="admin-login-form"
        >
          <div className="text-xs uppercase tracking-[0.25em] text-[#1A365D] font-semibold mb-4">
            Grime Master portal
          </div>
          <h1 className="font-serif text-4xl text-[#111827] leading-tight">
            Welcome back.
          </h1>
          <p className="mt-3 text-[#4B5563] font-light">
            Sign in to review requests and manage your Saturday schedule.
          </p>

          <div className="mt-8 space-y-4">
            <div>
              <label className="block text-xs uppercase tracking-[0.15em] text-[#4B5563] mb-2">
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoFocus
                className="w-full rounded-2xl border border-black/10 bg-[#F9F9F6] px-4 py-3 text-[#111827] focus:outline-none focus:ring-2 focus:ring-[#1A365D]/30"
                data-testid="admin-username-input"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.15em] text-[#4B5563] mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-2xl border border-black/10 bg-[#F9F9F6] px-4 py-3 text-[#111827] focus:outline-none focus:ring-2 focus:ring-[#1A365D]/30"
                data-testid="admin-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="mt-8 inline-flex items-center justify-center gap-2 w-full rounded-full bg-[#1A365D] text-white uppercase tracking-[0.18em] text-sm py-4 hover:bg-[#2B4C7E] transition-colors disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? (
              "Signing in…"
            ) : (
              <>
                <LogIn className="h-4 w-4" />
                Sign in
              </>
            )}
          </button>
        </form>
      </main>
    </div>
  );
}
